export const ENV_LOCAL = 'LOCAL';
export const ENV_DEV = 'DEV';
export const ENV_UAT = 'UAT';
export const ENV_PROD = 'PROD';

export const TAG_TYPE_T1_HEADER = 'T1 Header';

export const DEFAULT_OPTION_ID_FIELD_NAME = 'id';
export const DEFAULT_OPTION_TEXT_FIELD_NAME = 'name';

export const DEFAULT_TRANSMITTAL_HISTORY_PAGE_SIZE_XXL = 10;
export const DEFAULT_TRANSMITTAL_HISTORY_PAGE_SIZE_LG = 8;
export const DEFAULT_TRANSMITTAL_HISTORY_PAGE_SIZE_MD = 5;

export const TRANSMITTAL_ITEM_REVISION_COLUMN_WIDTH = 75;

export const AXIOS_API_SERVER = 'AXIOS_API_SERVER';
export const DEFAULT_SELECT_PAGE_SIZE = 20;
export const DEFAULT_TABLE_PAGE_SIZE = 100;
export const DEFAULT_TABLE_PAGE_SIZE_OPTIONS = [
  { key: 25, text: 25, data: 25 },
  { key: 50, text: 50, data: 50 },
  { key: 100, text: 100, data: 100 },
  { key: 200, text: 200, data: 200 },
  { key: 500, text: 500, data: 500 },
];

export const FETCH_QUERIES_NAME = {
  MASTER_SCHEDULE_SEARCH: 'fetchMasterScheduleSearch',
  MASTER_SCHEDULE_OPTIONS: 'fetchMasterScheduleOptions',
  MASTER_SCHEDULE_OPTIONS_FOR_TRANSMITTAL: 'fetchMasterScheduleOptionsForTransmittal',
  MASTER_SCHEDULE_OPTIONS_FOR_DESIGN_BFIEF: 'fetchMasterScheduleOptionsForDesignBrief',
  MASTER_SCHEDULE_OPTIONS_FOR_DESIGN_MODIFICATION: 'fetchMasterScheduleOptionsForDesignModification',
  MASTER_SCHEDULE_OPTIONS_FOR_LOADING_REMOVAL_CERT: 'fetchMasterScheduleOptionsForLoadingRemovalCert',
  MASTER_SCHEDULE_TWC_OPTIONS_FOR_LOADING_REMOVAL_CERT: 'fetchMasterScheduleTwcOptionsForLoadingRemovalCert',
  MASTER_SCHEDULE_OPTIONS_FOR_ASSIGN_T1_TEAMS: 'fetchMasterScheduleOptionsForAssignT1Teams',
  MASTER_SCHEDULE_DETAIL: 'fetchMasterScheduleDetail',
  MASTER_SCHEDULE_TAGS_SEARCH: 'fetchMasterScheduleTagsSearch',
  CHECKER_COMPANY_OPTIONS: 'fetchCheckerCompanyOptions',
  DESIGNER_COMPANY_OPTIONS: 'fetchDesignerCompanyOptions',
  REVIEWER_COMPANY_OPTIONS: 'fetchReviewerCompanyOptions',
  SRP_OPTIONS: 'fetchSrpOptions',
  TWC_OPTIONS: 'fetchTwcOptions',
  TWCM_OPTIONS: 'fetchTwcmOptions',
  RSE_OPTIONS: 'fetchRseOptions',
  TRANSMITTAL_SEARCH: 'fetchTransmittalSearch',
  TRANSMITTAL: 'fetchProjectTransmittalById',
  LATEST_TRANSMITTAL: 'fetchLatestProjectTransmittalByMasterScheduleId',
  TRANSMITTAL_SITE_TRANSMITTAL_FOR_CHECKER_OPTIONS: 'fetchProjectTransmittalSiteTransmittalForCheckerOptions',
  TRANSMITTAL_SITE_TRANSMITTAL_FOR_REVIEWER_OPTIONS: 'fetchProjectTransmittalSiteTransmittalForReviewerOptions',
  TRANSMITTAL_DISTRIBUTION: 'fetchProjectTransmittalDistribution',
  TRANSMITTAL_HISTORIES: 'fetchTransmittalHistories',
  TRANSMITTAL_HISTORIES_ITEMS: 'fetchTransmittalHistoriesItems',
  TRANSMITTAL_PURPOSE_OPTIONS: 'fetchTransmittalPurposeOptions',
  TRANSMITTAL_ITEMS_WITH_LATEST_REVISION: 'fetchTransmittalItemsWithLatestRevision',
  TRANSMITTAL_ITEMS: 'fetchTransmittalItems',
  TRANSMITTAL_ITEMS_DRAWINGS: 'fetchTransmittalItemsDrawings',
  COMPANY_OPTIONS: 'fetchCompanyOptions',
  PROJECT_COMPANY: 'fetchProjectCompany',
  PROJECT_COMPANY_ALL_WITH_ROLES_AND_USERS: 'fetchAllCompaniesWithRolesAndUsers',
  COMPANY_TYPES: 'fetchCompanyTypes',
  ORGANIZATION_TYPES: 'fetchOrganizationTypes',
  LIST_ITEM: 'fetchListItem',
  DESIGN_BRIEF_SEARCH: 'fetchDesignBriefSearch',
  INFO_ATTACHED_OPTIONS: 'fetchInfoAttachedOptions',
  DESIGN_BRIEF_DETAIL: 'fetchDesignBriefDetail',
  LOADING_REMOVAL_CERT_SEARCH: 'fetchLoadingRemovalCertSearch',
  LOADING_REMOVAL_CERT_DETAIL: 'fetchLoadingRemovalCertDetail',
  LOADING_REMOVAL_CERT_REVISIONS: 'fetchLoadingRemovalCertRevisions',
  LOADING_REMOVAL_CERT_REMOVAL_CERTS: 'fetchLoadingRemovalCertRemovalCerts',
  LOADING_REMOVAL_CERT_DRAWINGS: 'fetchLoadingRemovalCertDrawings',
  LOADING_REMOVAL_CERT_T3: 'fetchLoadingRemovalCertT3',
  LOADING_REMOVAL_CERT_CHECKLIST: 'fetchLoadingRemovalCertCheckList',
  LOADING_REMOVAL_CERT_CHECKLIST_COUNT: 'fetchLoadingRemovalCertCheckListCount',
  LOADING_REMOVAL_CERT_MOBILE_ACTION_USAGE: 'fetchLoadingRemovalCertMobileActionUsage',
  PROJECT_DISCUSSION_LIST: 'fetchProjectDiscussionList',
  DRAWINGS: 'fetchDrawings',
  REASON_OF_CHANGE_OPTIONS: 'fetchReasonOfChangeOptions',
  DESIGN_MODIFICATION_SEARCH: 'fetchDesignModificationSearch',
  DESIGN_MODIFICATION_DETAIL: 'fetchDesignModificationDetail',
  DESIGN_MODIFICATION_REVISIONS: 'fetchDesignModificationRevisions',
  DESIGN_MODIFICATION_OPTION_FOR_DESIGNER_TRANSMITTAL: 'fetchDesignModificationOptionForDesignerTransmittal',
  DESIGN_MODIFICATION_OPTIONS_FOR_LOADING_REMOVAL_CERT: 'fetchDesignModificationOptionsForLoadingRemovalCert',
  SEARCH_USER_INFO: 'fetchSearchUserInfo',
  GET_MY_SIGNATURE: 'fetchMySignature',
  ALL_PROJECT_USER_PROFILES: 'fetchAllUserProfiles',
  PROJECT_USER_PROFILE: 'fetchUserProfile',
  PROJECT_USER_PROFILE_OPTIONS: 'fetchProjectUserProfileOptions',
  USER_PROFILE_OPTIONS: 'fetchUserProfileOptions',
  SEARCH_PROJECT_USER_PROFILE_OPTIONS: 'fetchProjectUserProfileOptionsWithSearch',
  MY_PROJECT_USER_PROFILE: 'fetchMyUserProfile',
  TEAMS_WITH_USER: 'fetchTeamsWithUser',
  ROLES: 'fetchRoles',
  ROLES_WITH_USER: 'fetchRolesWithUser',
  GLOBAL_ROLES_WITH_USER: 'fetchGlobalRolesWithUser',
  ROLE_OPTIONS: 'fetchRoleOptions',
  ROLES_PROJECT_REQUEST: 'fetchRolesProjectRequest',
  RISK_CATEGORIES: 'fetchAllRiskCategories',
  TRANSMITTAL_ITEM_DOCUMENT_TYPES: 'fetchAllTransmittalItemDocumentTypes',
  PERMITTED_RISK_CATEGORIES: 'fetchAllPermittedRiskCategories',
  TAG_TYPE_OPTIONS: 'fetchAllTagTypeOptions',
  MY_PERMISSIONS: 'fetchMyPermissions',
  PROJECT_REQUEST_DETAIL: 'fetchProjectRequestDetail',
  PROJECT_REQUEST_DETAIL_COMPANIES: 'fetchProjectRequestDetailCompanies',
  PROJECT_REQUEST_DETAIL_TEAMS: 'fetchProjectRequestDetailTeams',
  PROJECT_REQUEST_DETAIL_USERS: 'fetchProjectRequestDetailUsers',
  PROJECT_REQUEST_BY_PROFILE_ID: 'fetchProjectRequestByProfileId',
  PROJECT_REQUEST_DEFAULT_COMPANIES: 'fetchProjectRequestDefaultCompanies',
  VO_ITEM: 'fetchAllVoItems',
  MY_DATA: 'fetchMyData',
  USER_AVATAR: 'fetchUserAvatar',
  PROJECT_DATA_ALL: 'fetchProjectDataAll',
  PROJECT_BY_PROJECT_NO: 'fetchProjectByProjectNo',
  TEAMS_OPTIONS_BY_COMPANY_TYPE_ID_ORGANIZATION_TYPE_ID: 'fetchTeamsOptionsByCompanyTypeIdOrganizationTypeId',
  TEAMS_OPTIONS_BY_COMPANY_CODE: 'fetchTeamsOptionsByCompanyCode',
  TEAMS_OPTIONS_BY_COMPANY_ID: 'fetchTeamsOptionsByCompanyId',
  PROJECT_SEARCH: 'fetchProjectSearch',
  COMPANY_DISTRIBUTION_OPTIONS: 'fetchCompanyDistributionOptions',
  ROLE_DISTRIBUTION_OPTIONS: 'fetchRoleDistributionOptions',
  USER_DISTRIBUTION_OPTIONS_SEARCH: 'fetchUserDistributionOptionsSearch',
  TEAM_DISTRIBUTION_OPTIONS_SEARCH: 'fetchTeamDistributionOptionsSearch',
  PROJECT_FILE_ATTACHMENTS_TRANSMITTALS: 'fetchProjectFileAttachmentsTransmittals',
  PROJECT_FILE_ATTACHMENTS_MASTER_SCHEDULES: 'fetchProjectFileAttachmentsMasterSchedules',
  PROJECT_FILE_ATTACHMENTS_DESIGN_BRIEFS: 'fetchProjectFileAttachmentsDesignBriefs',
  PROJECT_FILE_ATTACHMENTS_DESIGN_MODIFICATIONS: 'fetchProjectFileAttachmentsDesignModifications',
  PROJECT_FILE_ATTACHMENTS_LOADING_REMOVAL_CERTS: 'fetchProjectFileAttachmentsLoadingRemovalCerts',
  DRAWING_SEARCH: 'fetchDrawingSearch',
  DRAWING_REGISTER: 'fetchDrawingRegister',
  DRAWING_HISTORIES: 'fetchDrawingHistories',
  PROJECT_FILE_ATTACHMENTS_TWC_GE_REQUESTS: 'fetchProjectFileAttachmentsTwcGeRequests',
  PROJECT_TWC_GE_REQUEST_PROPOSED_AS_OPTIONS: 'fetchProjectTwcGeRequestProposedAsOptions',
  PROJECT_TWC_GE_REQUESTS: 'fetchAllProjectTwcGeRequests',
  PROJECT_TWC_GE_REQUEST_BY_ID: 'fetchProjectTwcGeRequestById',
  DESIGN_BRIEF_BY_T1: 'fetchDesignBriefByT1',
  DESIGN_MODIFICATION_BY_T1: 'fetchDesignModificationByT1',
  LOADING_REMOVAL_CERT_BY_T1: 'fetchLoadingRemovalCertByT1',
  DESIGNER_TRANSMITTAL_BY_T1: 'fetchDesignerTransmittalByT1',
  SITE_TRANSMITTAL_BY_T1: 'fetchSiteTransmittalByT1',
  CHECKER_TRANSMITTAL_BY_T1: 'fetchCheckerTransmittalByT1',
  REVIEWER_TRANSMITTAL_BY_T1: 'fetchReviewerTransmittalByT1',
  CHECK_CERTIFICATES_BY_T1: 'fetchCheckCertificatesByT1',
  USER_PROFILE_PREFERENCES: 'fetchUserProfilePreferences',
  MY_GEMS: 'fetchMyGems',
  ADMIN_TEAM_INFO: 'fetchTeamInfo',
  ANNOUNCEMENT_SEARCH: 'fetchAnnouncementSearch',
  ANNOUNCEMENT_DETAIL: 'fetchAnnouncementDetail',
  GLOBAL_ROLES_BY_USER_PROFILE_ID: 'fetchGlobalRolesByUserProfileId',
  GLOBAL_ROLE_OPTIONS: 'fetchGlobalRoleOptions',
  USER_PROFILE: 'fetchUserProfile',
  TRAINING: 'fetchTraining',
  ICE_CERT: 'fetchIceCert',
  ADMIN_PROJECT_USER_PROFILE_WITH_ROLES_BY_COMPANY: 'fetchAdminProjectUserProfileWithRolesByCompany',
  ADMIN_SIGNATURE: 'fetchAdminSignature',
};

export const MUTATION_KEYS = {
  GET_ROLE_OPTIONS: 'fetchRoleOptions',
  CREATE_MY_SIGNATURE: 'createMySignature',
  UPDATE_MY_SIGNATURE: 'updateSignature',
  CREATE_PROJECT_TEAM: 'createProjectTeam',
  UPDATE_PROJECT_TEAM: 'updateProjectTeam',
  DELETE_PROJECT_TEAM: 'deleteProjectTeam',
  CREATE_PROJECT_COMPANY: 'createProjectCompany',
  UPDATE_PROJECT_COMPANY: 'updateProjectCompany',
  DELETE_PROJECT_COMPANY: 'deleteProjectCompany',
  SYNC_USER_PROFILE: 'syncUserProfile',
  CREATE_PROJECT_USER_PROFILE: 'createProjectUserProfile',
  UPDATE_PROJECT_USER_PROFILE: 'updateProjectUserProfile',
  REMOVE_USER_FROM_COMPANY: 'removeUserFromCompany',
  LOCK_PROJECT_USER_PROFILE: 'lockProjectUserProfile',
  UNLOCK_PROJECT_USER_PROFILE: 'unlockProjectUserProfile',
  CREATE_DRAFT_PROJECT_TRANSMITTAL: 'createDraftProjectTransmittal',
  UPDATE_PROJECT_TRANSMITTAL: 'updateProjectTransmittal',
  DELETE_PROJECT_TRANSMITTAL: 'deleteProjectTransmittal',
  ENDORSE_PROJECT_TRANSMITTAL: 'endorseProjectTransmittal',
  REQUEST_ENDORSE_PROJECT_TRANSMITTAL: 'requestEndorseProjectTransmittal',
  RELEASE_FOR_CONSTRUCTION_PROJECT_TRANSMITTAL: 'releaseForConstructionProjectTransmittal',
  UPLOAD_PROJECT_FILE_DRAWING: 'uploadProjectFileDrawing',
  UPLOAD_PROJECT_FILE_ATTACHMENT: 'uploadProjectFileAttachment',
  UPLOAD_PROJECT_FILE_DISCUSSION_ATTACHMENT: 'uploadProjectFileDiscussionAttachment',
  CREATE_TRANSMITTAL_DISTRIBUTION_TEAM: 'createTransmittalDistributionTeam',
  CREATE_TRANSMITTAL_DISTRIBUTION_ROLE: 'createTransmittalDistributionRole',
  CREATE_TRANSMITTAL_DISTRIBUTION_USER: 'createTransmittalDistributionUser',
  DELETE_TRANSMITTAL_DISTRIBUTION_TEAM: 'deleteTransmittalDistributionTeam',
  DELETE_TRANSMITTAL_DISTRIBUTION_ROLE: 'deleteTransmittalDistributionRole',
  DELETE_TRANSMITTAL_DISTRIBUTION_USER: 'deleteTransmittalDistributionUser',
  UPSERT_PROJECT_TRANSMITTAL_ITEM_REVISION: 'upsertProjectTransmittalItemRevision',
  UPDATE_PROJECT_TRANSMITTAL_ITEM_REVISION: 'updateProjectTransmittalItemRevision',
  DELETE_PROJECT_TRANSMITTAL_ITEM_REVISION: 'deleteProjectTransmittalItemRevision',
  CREATE_PROJECT_TRANSMITTAL_ITEM_REVISION: 'createProjectTransmittalItemRevision',
  UPDATE_PROJECT_TRANSMITTAL_ITEM_REMOVE_FROM_USE: 'updateProjectTransmittalItemRemoveFromUse',
  UPDATE_PROJECT_TRANSMITTAL_ITEM_REUSE: 'updateProjectTransmittalItemReuse',
  UPDATE_PROJECT_TRANSMITTAL_ITEM: 'updateProjectTransmittalItem',
  DELETE_PROJECT_TRANSMITTAL_ITEM: 'deleteProjectTransmittalItem',
  CHECK_PROJECT_TRANSMITTAL_ITEM_DOC_NO: 'checkProjectTransmittalItemDocNo',
  DELETE_PROJECT_FILE: 'deleteProjectFile',
  CREATE_PROJECT_DISCUSSION: 'createProjectDiscussion',
  UPDATE_PROJECT_DISCUSSIONS_AS_DRAFT: 'updateProjectDiscussionsAsDraft',
  UPDATE_PROJECT_DISCUSSIONS_AS_ISSUE: 'updateProjectDiscussionsAsIssue',
  UPDATE_PROJECT_DISCUSSION_AS_DRAFT: 'updateProjectDiscussionAsDraft',
  UPDATE_PROJECT_DISCUSSION_AS_ISSUE: 'updateProjectDiscussionAsIssue',
  UPDATE_PROJECT_DISCUSSION_REPLYS_AS_DRAFT: 'updateProjectDiscussionRepliesAsDraft',
  UPDATE_PROJECT_DISCUSSION_REPLYS_AS_ISSUE: 'updateProjectDiscussionRepliesAsIssue',
  UPDATE_PROJECT_DISCUSSION_REPLY_AS_DRAFT: 'updateProjectDiscussionReplyAsDraft',
  UPDATE_PROJECT_DISCUSSION_REPLY_AS_ISSUE: 'updateProjectDiscussionReplyAsIssue',
  DELETE_PROJECT_DISCUSSION: 'deleteProjectDiscussion',
  CREATE_DESIGN_BRIEF: 'createDesignBrief',
  CREATE_AND_ISSUE_DESIGN_BRIEF: 'createAndIssueDesignBrief',
  CREATE_DESIGN_MODIFICATION: 'createDesignModification',
  CREATE_DESIGN_MODIFICATION_WITH_APPROVAL: 'createDesignModificationWithApproval',
  CREATE_DESIGN_MODIFICATION_REVISION: 'createDesignModificationRevision',
  UPDATE_DESIGN_MODIFICATION: 'updateDesignModification',
  UPDATE_DESIGN_BRIEF: 'updateDesignBrief',
  APPROVE_DESIGN_MODIFICATION: 'approveDesignModification',
  APPROVE_AND_CHECKED_DESIGN_MODIFICATION_AS_LAMBETH: 'approveAndCheckedDesignModificationAsLambeth',
  REASSIGN_CHECKER_DESIGN_MODIFICATION: 'reassignCheckerDesignModification',
  REQUEST_ENDORSEMENT_DESIGN_MODIFICATION: 'requestEndorsementDesignModification',
  CANCEL_DESIGN_MODIFICATION: 'cancelDesignModification',
  CREATE_LOADING_REMOVAL_CERT: 'createLoadingRemovalCert',
  UPDATE_LOADING_REMOVAL_CERT: 'updateLoadingRemovalCert',
  DELETE_LOADING_REMOVAL_CERT: 'deleteLoadingRemovalCert',
  CREATE_LOADING_REMOVAL_CERT_REVISION: 'createLoadingRemovalCertRevision',
  CREATE_LOADING_REMOVAL_CERT_REMOVAL_CERT: 'createLoadingRemovalCertRemovalCert',
  REQUEST_LOADING_REMOVAL_CERT_ICE_CERT: 'requestLoadingRemovalCertIceCert',
  ISSUE_LOADING_REMOVAL_CERT_SRP: 'issueLoadingRemovalCertSrp',
  APPROVE_LOADING_REMOVAL_CERT_TWC: 'approveLoadingRemovalCertTwc',
  APPROVE_LOADING_REMOVAL_CERT_ICE: 'approveLoadingRemovalCertIce',
  SAVE_PROJECT_TWC_GE_REQUEST_AS_DRAFT: 'saveProjectTwcGeRequestAsDraft',
  ISSUE_PROJECT_TWC_GE_REQUEST_TO_PM: 'issueProjectTwcGeRequestToPm',
  APPROVE_PROJECT_TWC_GE_REQUEST_BY_PM: 'approveProjectTwcGeRequestByPm',
  APPROVE_PROJECT_TWC_GE_REQUEST_BY_EM: 'approveProjectTwcGeRequestByEm',
  APPROVE_PROJECT_TWC_GE_REQUEST_BY_HOE: 'approveProjectTwcGeRequestByHoe',
  CANCEL_PROJECT_TWC_GE_REQUEST: 'cancelProjectTwcGeRequest',
  REVOKE_PROJECT_TWC_GE_REQUEST: 'revokeProjectTwcGeRequest',
  SAVE_PROJECT_REQUEST_AS_DRAFT: 'saveProjectRequestAsDraft',
  REQUEST_PROJECT_REQUEST_ENDORSEMENT: 'requestProjectRequestEndorsement',
  ENDORSE_AND_SUBMIT_PROJECT_REQUEST: 'endorseAndSubmitProjectRequest',
  APPROVE_PROJECT_REQUEST_AND_CREATE_PROJECT: 'approveProjectRequestAndCreateProject',
  UPSERT_PROJECT_TEAM_MASTER_SCHEDULE: 'upsertProjectTeamMasterSchedule',
  CANCEL_MASTER_SCHEDULE: 'cancelMasterSchedule',
  UNCANCEL_MASTER_SCHEDULE: 'uncancelMasterSchedule',
  UPDATE_USER_PROFILE_PREFERENCES: 'updateUserProfilePreferences',
  CREATE_MY_GEMS: 'createMyGems',
  UPDATE_MY_GEMS: 'updateMyGems',
  UPDATE_ADMIN_TEAM_INFO: 'updateAdminTeamInfo',
  UPDATE_PROJECT_INFO: 'updateProjectInfo',
  UPLOAD_ANNOUNCEMENT_FILE: 'uploadAnnouncementFile',
  CREATE_ANNOUNCEMENT: 'createAnnouncement',
  UPDATE_ANNOUNCEMENT: 'updateAnnouncement',
  GET_ANNOUNCEMENT_NON_EXPIRED: 'getAnnouncementNonExpired',
  UPDATE_GLOBAL_ROLES: 'updateGlobalRoles',
  UPDATE_USER_PROFILE_SYNC_NO_ACCOUNT_USERS: 'updateUserProfileSyncNoAccountUsers',
  REPLACE_DUMMY_USER_PROFILES: 'replaceDummyUserProfiles',
  UPDATE_USER_PROFILE: 'updateUserProfile',
  LOCK_MASTER_SCHEDULE: 'lockMasterSchedule',
  UNLOCK_MASTER_SCHEDULE: 'unlockMasterSchedule',
  CREATE_TRAINING: 'createTraining',
  UPDATE_TRAINING: 'updateTraining',
  SYNC_TRAINING: 'syncTraining',
  SYNC_TRAINING_BY_USER: 'syncTrainingByUser',
  ARCHIVE_PROJECT: 'archiveProject',
  UNARCHIVE_PROJECT: 'unarchiveProject',
  UPDATE_ICE_CERT: 'updateIceCert',
  ADMIN_UPDATE_SIGNATURE: 'adminUpdateSignature',
  ADMIN_CREATE_SIGNATURE: 'adminCreateSignature',
  UPDATE_MASTER_SCHEDULE_TAGS: 'updateMasterScheduleTags',
  DELETE_MASTER_SCHEDULE_TAGS: 'deleteMasterScheduleTags',
  ADD_PROJECT_INTERESTED: 'addProjectInterested',
  DELETE_PROJECT_INTERESTED: 'deleteProjectInterested',
  BATCH_ADD_MASTER_SCHEDULE: 'batchAddMasterSchedules',
  ADMIN_UPDATE_PROJECT_USER_PROFILE: 'adminUpdateProjectUserProfile',
  CREATE_ROLE: 'createRole',
  CREATE_PROJECT_ROLE: 'createProjectRole',
  CREATE_PERMISSION: 'createPermission',
  CREATE_ROLE_PERMISSION: 'createRolePermission',
  UPDATE_USER_RESIGNED_STATUS: 'updateUserResignedStatus',
};

export const SITE_OPERATIONS_TEAM_NAME = 'Site Operations Team';
export const SITE_DESIGN_TEAM = 'Site Design Team';

export const NULL_OPEN_PORTAL_EVENT = { currentTarget: true };
export const ALL_USERS_TEAM_NAME = 'All Users';

export const DATE_TIME_FILTER_FROM_FIELD_NAME = 'from';
export const DATE_TIME_FILTER_TO_FIELD_NAME = 'to';
export const SELECT_FILTER_ID_FIELD_NAME = 'id';

export const KEY_SEPARATOR = '--';

export const PURPOSE_CODE_Z = 'Z';

export const ERROR_CODE = {
  ERR_SIGN_NOT_FOUND: 'ERR_SIGN_NOT_FOUND',
};

export const LOCAL_STORAGE_KEYS = {
  ANNOUNCEMENT_READ: 'ANNOUNCEMENT_READ',
  RECENT_PROJECTS: 'RECENT_PROJECTS',
  DO_NOT_SHOW_TRANSMITTAL_ITEM_NOT_IN_USE_MODAL_AGAIN: 'DO_NOT_SHOW_TRANSMITTAL_ITEM_NOT_IN_USE_MODAL_AGAIN',
  DO_NOT_SHOW_TRANSMITTAL_ITEM_REUSE_MODAL_AGAIN: 'DO_NOT_SHOW_TRANSMITTAL_ITEM_REUSE_MODAL_AGAIN',
};

export const EVENT_NAME = {
  SET_LOCAL_STORAGE: 'SET_LOCAL_STORAGE',
};

export const SYSTEM_ACCOUNT_DISPLAY_NAME = 'System Account';

export const MACOSX_PREFIX = '__MACOSX';
